import { call, put } from 'redux-saga/effects';
import { CallApi } from '../api/callApi';
import { ACTIONS, APIS, STORAGE, STORE_STORAGE } from '../../_config'


export function* getTopics(action: any): any {
    try {
        const data = action.payload;
        // console.log('data', data);
        const resp = yield call(CallApi.GET, APIS.TOPIC.TOPIC_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}

export function* getWords(action: any): any {
    try {
        const data = action.payload;
        // console.log('data', data);
        const resp = yield call(CallApi.GET, APIS.WORD.WORD_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300) {
            action && action.callbackSuccess && action.callbackSuccess(resp);
        } else {
            action && action.callbackError && action.callbackError(resp);
        }
    } catch (e) {
        action && action.callbackError && action.callbackError(e);
    }
}